const { createApp: createSnpApp, nextTick } = Vue
createSnpApp({
  data() {
    return {
      all_benefit_points: null,
      collection_id: null,
      section_settings: null,
      product_objs: [],
      flavors: [],
      groupped_products: {},
      selected_flavor: null,
      packages: [{month: 1, sachet: 20},{month: 3, sachet: 60},{month: 6, sachet: 120},{month: 12, sachet: 240}],
      discovery_packages: [{month: 1, sachet: 10},{month: 3, sachet: 30},{month: 6, sachet: 60},{month: 12, sachet: 120}], // check this
    }
  },
  watch: {
    /*product_ids_list:{ // make me
      handler(val) {
        if(typeof exchangePrices === 'function') {
          exchangePrices()
        }
      },
      immediate: true,
    },*/
  },
  methods: {
    animationShake(i) {
      gsap.fromTo(i, {x: -5}, {
        duration: .1,
        x: 5,
        repeat: 3,
        yoyo: !0,
        ease: "power1.inOut",
        onComplete: function() {
          gsap.to(i, {
            x: 0
          })
        }
      })
    },
    animationATC(clone_id, animation_target, image_url) {
      var s = document.getElementById(clone_id)
        , n = document.getElementById(animation_target);
      if(n.offsetParent !== null) {
        if(s.style.backgroundImage != `url(${image_url})`) {
          s.style.backgroundImage = `url(${image_url})`
        }
        s.style.display = 'block';
        var l = s.getBoundingClientRect()
          , d = n.getBoundingClientRect()
          , _ = d.left - l.left
          , h = d.top - l.top;
        gsap.to(s, {
          zIndex: 10000,
          duration: 1,
          x: _,
          y: h,
          scale: .1,
          opacity: 0.1,
          rotation: 360,
          ease: "power1.inOut",
          transformOrigin: "top left",
          onComplete: () => {
            gsap.set(s, {
              clearProps: "all"
            })
            if(s.style.backgroundImage != `url(${image_url})`) {
              s.style.backgroundImage = `url(${image_url})`
            }
            s.style.display = 'none';
            this.animationShake(n)
          }
        })
      }
    },
    retrieveProduct(product_title) {
      product_title = product_title.toLowerCase();
      switch (true) {
        case product_title.includes('pineapple crush'):
          return "Pineapple Crush";
        case product_title.includes('perfectly peach'):
          return "Per&shyfect&shyly Peach";
        case product_title.includes('apple pie'):
          return "Apple Pie";
        case product_title.includes('berry fusion'):
          return "Berry Fusion";
        case product_title.includes('cherry surge'):
          return "Cherry Surge";
        case product_title.includes('strawberry lemonade'):
          return "Straw&shyber&shyry Le&shymo&shynade";
        case product_title.includes('discovery pack'):
          return "Dis&shycovery Pack";
        case product_title.includes('better than - ashwagandha'):
        case product_title.includes('better than ashwagandha'):
          return "Ash&shywa&shygan&shydha";
        case product_title.includes('better than - glutathione'):
        case product_title.includes('better than glutathione'):
          return "Glu&shyta&shythi&shyone";
        case product_title.includes('better than - resveratrol'):
        case product_title.includes('better than resveratrol'):
          return "Res&shyve&shyrat&shyrol";
        case product_title.includes('cheat'):
          return "Cheat";
        case product_title.includes('lucid'):
          return "Lucid";
        case product_title.includes('pro'):
          return "Pro";
        case product_title.includes('shield'):
          return "Shield";
        case product_title.includes('sprint'):
          return "Sprint";
        case product_title.includes('zeus'):
          return "Zeus";
        default:
          return "Unknown";
      }
    },
    getVariant(product, attribute, is_sub = false) { //fix me
      let c_variant
      let ret_value
      
      c_variant = product.variants.find(v => (v.is_sub === is_sub) && (v.sachet === product.sachet))
      if(c_variant) {
        ret_value = c_variant[attribute]
      }
      if((typeof exchangePrices === 'function') && ((attribute === 'price') || (attribute === 'compare_at_price'))) {
        nextTick(() => this.fixAndExchange(product.id, c_variant.id))
      }
      return ret_value
    },
    fixAndExchange(product_id, variant_id) {
      nextTick(() => {
        let price_els = document.querySelectorAll(`#snp_pc_${product_id} [data-variant="${variant_id}"]`)
        console.log('price_els length: ', price_els.length)
        price_els.forEach(el => {
          el.removeAttribute('data-exchanged-to')
        })
        exchangePrices()
      })
    },
    addToCart(product) {
      product.err = ''
      let formData = {'items': [{
        'id': product.variant,
        'quantity': 1
      }]}
      if(product.sub) {
        formData['attributes[_plan]'] = 1
        formData['properties[_plan]'] = 1
      }
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(r => {
        if(typeof r.items != 'undefined') {
          this.animationATC(`${product.id}_clone`, 'toggle-cart-drawer', product.image)
          this.updateCart(r.items.map(l => {
            let line = {}
            line[l.id] = l.quantity
            return line
          }))
        }
        if(typeof r.message != 'undefined') {
          product.err = r.message
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    updateCart(items) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(response => {
        return response.json();
      })
      .then(r => {
        if(typeof r.items != 'undefined') {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }))
          /*const cart_drawer = document.querySelector('.cart-drawer');
          if(cart_drawer) {
            cart_drawer.show();
          }*/
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
    },
    resizeImage(src, width, height) {
      let resized = ''+src
      if(width) {
        resized = resized+(resized.indexOf('?') > -1 ? '&' : '?')+'width='+width
      }
      if(height) {
        resized = resized+(resized.indexOf('?') > -1 ? '&' : '?')+'height='+height
      }
      if(width && height) {
        resized = resized+(resized.indexOf('?') > -1 ? '&' : '?')+'crop=center'
      }
      return resized
    },
    groupProducts() {
      this.product_objs.forEach(p_obj => {
        let base_product = this.retrieveProduct(p_obj.title)
        if(typeof this.groupped_products[base_product] === 'undefined') {
          this.groupped_products[base_product] = {
            id: null, title: null, featured_image: null, color: null, variants: [], benefits: [], //base values of the product
            sub: false, variant: null, image: null, sachet: null, url: null, err: null, // dynamic values set by the selected variant or package
          }
        }
        if(p_obj.is_sub === false) {
          if(!this.selected_flavor) {
            this.selected_flavor = p_obj.id
          }
          this.groupped_products[base_product].id = p_obj.id
          this.groupped_products[base_product].title = p_obj.title
          this.groupped_products[base_product].featured_image = p_obj.featured_image
          this.groupped_products[base_product].color = p_obj.color
          if(this.all_benefit_points[this.collection_id] && this.all_benefit_points[this.collection_id][p_obj.id]) {
            this.groupped_products[base_product].benefits = this.all_benefit_points[this.collection_id][p_obj.id]
          }
          let three_month = p_obj.variants.find(v => v.sachet === 60)
          this.groupped_products[base_product].variant = three_month.id
          this.groupped_products[base_product].image = three_month.image
          this.groupped_products[base_product].sachet = three_month.sachet
          this.groupped_products[base_product].url = three_month.url
          this.flavors.push({
            title: base_product,
            id: p_obj.id,
            srcset: ''+this.resizeImage(p_obj.featured_image, 80, 80)+' 1x, '+this.resizeImage(p_obj.featured_image, 160, 160)+' 2x',
            image: ''+p_obj.featured_image,
            color: p_obj.color,
          })
        }
        this.groupped_products[base_product].variants.push(...p_obj.variants)
      })
      console.log('groupProducts')
      /*console.log(`${this.collection_id}: { //https://admin.shopify.com/store/noobru/collections/${this.collection_id} - ${collection_title}`)
      Object.entries(this.groupped_products).forEach(gp => console.log(`${gp[1].id}: [], //${gp[0].split('&shy').join('')}`))
      console.log(`},`)*/
    },
    changePackage(product, to_sachet) {
      let right_variant = product.variants.find(v => (v.sachet === to_sachet) && (v.is_sub === product.sub))
      if(right_variant) {
        product.variant = right_variant.id
        product.image = right_variant.image
        product.sachet = to_sachet
        product.url = right_variant.url
        nextTick(() => this.fixAndExchange(product.id, right_variant.id))
      }
    },
    changeSub(product, to_sub) {
      let right_variant = product.variants.find(v => (v.is_sub === to_sub) && (v.sachet === product.sachet))
      if(right_variant) {
        product.variant = right_variant.id
        product.image = right_variant.image
        product.sub = to_sub
        product.url = right_variant.url
        nextTick(() => this.fixAndExchange(product.id, right_variant.id))
      }
    }
  },
  created() {
    if(typeof collection_id !== 'undefined') {
      this.collection_id = collection_id
      console.log('collection id: ', this.collection_id)
    }
    if(typeof shop_by_category_benefits !== 'undefined') {
      console.log('shop_by_category_benefits')
      this.all_benefit_points = JSON.parse(JSON.stringify(shop_by_category_benefits))
    }
    this.section_settings = JSON.parse(JSON.stringify(snp_section_settings))
    this.product_objs = JSON.parse(JSON.stringify(snp_product_objs))
    this.groupProducts()
  },
}).mount('#app_shop_now_page');